export default {"src":"/_next/static/media/lock.8a6af439.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};